<template>
  <div class="message-box d-flex align-items-center">
    <b-form-textarea
      ref="message"
      v-model="message"
      id="message-box-input"
      class="regular-input message-type-box m-0 px-3 py-2"
      :rows="1"
      :debounce="autosuggestEnabled ? 250 : 0"
      :placeholder="placeholder"
      :disabled="disabled"
      @keydown="keyPress"
      style="height:40px;font-size: 16px;"
    ></b-form-textarea>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";

export default {
  name: "MessageBox",
  props: {
    value: String,
    placeholder: String,
    disabled: Boolean,
  },
  data() {
    return {
      message: "",
      autoCompletionSuffix: "",
      autoCompletion: "",
      autoCompleted: false,
    };
  },
  computed: {
    ...mapGetters("conversations", ["conversationMessages"]),
    ...mapGetters("agency", ["agencySettings"]),
    autosuggestEnabled() {
      return this.agencySettings && this.agencySettings.enableAutosuggest == "true";
    },
  },
  created() {
    const self = this;
    setTimeout(function() {
      self.focusTextarea();
    }, 750);
  },
	mounted() {},
  methods: {
    keyPress(e) {
      this.autoCompleted = false;
      const keyCode = e.which || e.keyCode;
      
      if (keyCode === 13 && !e.shiftKey) {
        this.$emit("send-message", this.message);
      }
    },
    focusTextarea() {
      if (this.$refs.message) {
        this.$refs.message.focus();
      }
    }
  },
  watch: {
    value(newVal) {
      this.message = newVal;
    },
    async message(newVal) {
      this.$emit("input", newVal);
    },
  }
};
</script>

<style lang="scss" scoped>
.message-box {
	position: relative;
	&-list {
		position: absolute;
		z-index: 2;
		overflow: auto;
		min-width: 250px;
		max-height: 150px;
		margin: 0;
		margin-top: 5px;
		padding: 0;
		border: 1px solid #eee;
		list-style: none;
		border-radius: 4px;
		background-color: #fff;
		box-shadow: 0 5px 25px rgba(0, 0, 0, 0.05);

    textarea {
      font-size: 16px !important;
    }
	}

  textarea {
    border-radius: 1.5rem;
    resize: none;
  }
}
</style>